export default "__VITE_ASSET__hzXXqc5l__"